import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { gsap } from 'gsap';
import s1 from '../assets/img/s1.webp';
import s2 from '../assets/img/services.jpg';
import '../styles/Buysell.css';
import { IoIosArrowForward } from "react-icons/io";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { motion, useScroll, useTransform } from 'framer-motion';

gsap.registerPlugin(ScrollTrigger);

const text = [
  'Esateland has more than 30 years of experience in',
  ' real estate valuation, sales, and development.',
  ' Which allows us today to occupy an exceptional',
  ' place on the market. Our professional and dedicated',
  ' team possesses extensive proficiency in the',
  ' real estate brokerage field. We combine local',
  ' market insight, specialist expertise, and state',
  ' of the art tools and resources to deliver',
  'superior brokerage solutions.',
  'By our track record of success in',
  'acquiring properties by putting sellers',
  'needs and interests first.But in addition',
  'needs and know-how,negotiations we',
  'always strive to maintain transparency',
  'throughout the transaction process to',
  'ensure satisfaction for all parties involved',
].join(' ');


const Buysell = () => {
  const textLinesRef = useRef([]);
  const titleRef = useRef(null);
  const titleRef2 = useRef(null);
  const linkRefs = useRef([useRef(null), useRef(null), useRef(null)]);
  const line = useRef(null);

  const [imgIsVisible, setImgIsVisible] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isTitleVisible, setIsTitleVisible] = useState(false);
  const [titleAnimatedOnce, setTitleAnimatedOnce] = useState(false);
  const [imgAnimatedOnce, setImgAnimatedOnce] = useState(false);
  const [linksAnimatedOnce, setLinksAnimatedOnce] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const buysellSection = document.querySelector('.buysell-container');

      if (!buysellSection) return;

      const buysellTop = buysellSection.offsetTop;

      if (scrollPosition + windowHeight >= buysellTop + (buysellSection.offsetHeight * 0.1)) {
        setIsTitleVisible(true);
      } else {
        setIsTitleVisible(false);
      }

      if (scrollPosition + windowHeight >= buysellTop + (buysellSection.offsetHeight * 0.2)) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }

      if (scrollPosition + windowHeight >= buysellTop + (buysellSection.offsetHeight * 0.2)) {
        setImgIsVisible(true);
      } else {
        setImgIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (isTitleVisible && !titleAnimatedOnce) {
      gsap.to(titleRef.current, {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: 'power3.out'
      });
      gsap.to(titleRef2.current, {
        y: 0,
        opacity: 1,
        duration: 1.1,
        ease: 'power3.out'
      });
      setTitleAnimatedOnce(true);
    }
  }, [isTitleVisible, titleAnimatedOnce]);

  useEffect(() => {
    if (imgIsVisible && !imgAnimatedOnce) {
      gsap.from(document.querySelector('.s11 img'), {
        opacity: 0,
        y: 50,
        duration: 0.9,
        scrollTrigger: {
          trigger: document.querySelector('.s11'),
          start: "top center",
        },
      });
      setImgAnimatedOnce(true);
    }
  }, [imgIsVisible, imgAnimatedOnce]);

  useEffect(() => {
    if (isVisible && !linksAnimatedOnce) {
      gsap.fromTo(linkRefs.current, {
        opacity: 0,
        y: 50
      }, {
        opacity: 1,
        y: 0,
        duration: 0.9,
        stagger: 0.2,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: linkRefs.current[0],
          start: "top bottom",
        },
      });
      setLinksAnimatedOnce(true);
    }
  }, [isVisible, linksAnimatedOnce]);

  const textAnimation = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        delay: 0.2,
        duration: 0.6
      }
    }
  };

  useEffect(() => {
    if (isVisible) {
      gsap.to(titleRef.current, { y: 0, opacity: 1, duration: 1, ease: 'power3.out' });
      gsap.to(titleRef2.current, { y: 0, opacity: 1, duration: 1.1, ease: 'power3.out' });
    }
  }, [isVisible]);

  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"]
  });

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const y = useTransform(
    scrollYProgress,
    [0, 1],
    windowWidth < 768 ? ["-80%", "20%"] : ["-30%", "30%"]
  );

  return (
    <section className='relative md:flex-row-reverse buysell-container' style={{ margin: '2rem 0' }} ref={containerRef}>
      <div className="buysell_left_title md:text-4xl text-white ml-8 md:ml-8 flex mt-2 mb-8 md:flex-row items-center md:items-start">
        <h1 className="relative leading-[2.5rem] text-[3.5rem] font-normal tracking-tight md:flex object-cover" style={{ opacity: 0, transform: 'translateY(50px)' }} ref={titleRef}>Our real estate services</h1>
      </div>

      {/* Aici e modificarea cheie: ajustăm clasele pentru flexbox și margini/gap */}
      <div className="wrapper-img1 flex flex-col md:flex-row justify-start md:gap-x-8 lg:gap-x-12 xl:gap-x-16 md:ml-[2.5rem] sm:ml-8 ">
        {/* First image container */}
        <div className="relative h-[290px] overflow-hidden rounded-md flex-1 md:w-1/3"> {/* Am eliminat max-w-[340px] */}
          <div className='s11 w-full'>
            <motion.img
              className='w-full h-full object-cover s11_img'
              src={s1}
              alt="Real Estate Building"
              style={{ y }}
            />
          </div>
        </div>

        {/* Second image container */}
        <div className="relative overflow-hidden rounded-md scnd_buy_img flex-1 md:w-1/3 md:mt-0 mt-12"> {/* Am eliminat ml-8 și am pus mt-12 pentru mobil */}
          <motion.div
            className='big-imgb h-full rounded-md'
            style={{ y }}
          >
            <img className='h-full w-full object-cover' src={s2} alt="Services Illustration" />
          </motion.div>
        </div>

        {/* Text and services section */}
        <div className="wrapper-serv1 text-left lg:ml-8 mt-12 md:-mt-4 w-full text-[1.2rem] text-white flex-1 md:w-1/3">
          <div className='flex justify-start'>
            <h1 className="heading-bs top-heading text-white text-left text-[2rem] custom-margin" style={{ opacity: 0, transform: 'translateY(50px)' }} ref={titleRef2}>Services</h1>
          </div>

          <div className="desc-text w-full h-auto" ref={line}>
            <motion.p
              initial="hidden"
              animate={isVisible ? 'visible' : 'hidden'}
              variants={textAnimation}
              className='mr-4 md:mr-12 md:mt-16 mt-16 txt'
              ref={(el) => textLinesRef.current.push(el)}
            >
              {text}
            </motion.p>
          </div>

          <div className="services-wrapper1 justify-center flex-col md:flex-row md:w-full w-full">
            <div className="b-u text-white border-b justify-between duration-500 border-white transition inline-block" style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ opacity: isVisible ? 1 : 0 }} ref={el => linkRefs.current[0] = el} className="relative flex items-center justify-between flex-1">
                <Link to="/services_page/:serviceType" className='s_l transition flex items-center whitespace-nowrap'><h3>Real Estate Brokerage </h3></Link>
                <button className='serv_arrow rounded-full border border-indigo-700 w-5 h-5 text-white flex items-center justify-center hover:transform hover:scale-105 transition-transform'>
                  <IoIosArrowForward className='w-3 h-3' />
                </button>
              </div>
            </div>

            <div className="b-u text-white border-b duration-500 border-white justify-between transition inline-block" style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ opacity: isVisible ? 1 : 0 }} ref={el => linkRefs.current[1] = el} className="relative flex items-center justify-between flex-1">
                <Link to="/services_page/:serviceType" className='s_l transition flex items-center whitespace-nowrap'><h3>Revenue property brokerage</h3></Link>
                <button className='serv_arrow rounded-full border border-indigo-700 w-5 h-5 text-white flex items-center justify-center hover:transform hover:scale-105 transition-transform'>
                  <IoIosArrowForward className='w-3 h-3' />
                </button>
              </div>
            </div>

            <div className="b-u text-white border-b duration-500 border-white justify-between transition inline-block" style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ opacity: isVisible ? 1 : 0 }} ref={el => linkRefs.current[2] = el} className="relative flex items-center justify-between flex-1">
                <Link to="/services_page/:serviceType" className='s_l transition flex items-center whitespace-nowrap'><h3>Evaluation and prospect </h3></Link>
                <button className='serv_arrow rounded-full border border-indigo-700 w-5 h-5 text-white flex items-center justify-center hover:transform hover:scale-105 transition-transform'>
                  <IoIosArrowForward className='w-3 h-3' />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Buysell;